export class BaseActions {
    static ActionSpin: string = "SPIN";
    static ActionHoldSpin: string = "HOLD_";
    static ActionSpinStop: string = "SPIN_STOP";
    static ActionAutoplay: string = "AUTOPLAY";
    static ActionAutoplayStop: string = "AUTOPLAY_STOP";
    static ActionBetPlus: string = "BET_PLUS";
    static ActionBetMinus: string = "BET_MINUS";
    static ActionBetCycle: string = "BET_CYCLE";
    static ActionMaxBet: string = "MAX_BET";
    static ActionBaseCollect: string = "BASE_COLLECT";
    static ActionSelectPayline: string = "SELECT_PAYLINE_";
    static ActionDenomSelect: string = "DENOM_SELECT";
    static ActionDenomSelectValue: string = "DENOM_SELECT_VALUE_";
    static ActionCoinCountSelect: string = "COIN_COUNT_SELECT";
    static ActionCoinCountSelectValue: string = "COIN_COUNT_SELECT_VALUE_";
    static ActionBetSelect: string = "BET_SELECT";
    static ActionBetSelectValue: string = "BET_SELECT_VALUE_";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Actions/BaseActions.ts
 **/